package diana.soleil.design.iraniancanadienbazzar.core.model

import kotlin.math.asin
import kotlin.math.cos
import kotlin.math.sin
import kotlin.math.sqrt

/** A geographic point (WGS84). */
data class GeoPoint(val lat: Double, val lng: Double)

private const val EARTH_RADIUS_KM = 6371.0

private fun Double.toRadians(): Double = this * (kotlin.math.PI / 180.0)

/** Great-circle (haversine) distance in kilometres between two points. */
fun distanceKm(a: GeoPoint, b: GeoPoint): Double {
    val dLat = (b.lat - a.lat).toRadians()
    val dLng = (b.lng - a.lng).toRadians()
    val h = sin(dLat / 2) * sin(dLat / 2) +
        cos(a.lat.toRadians()) * cos(b.lat.toRadians()) * sin(dLng / 2) * sin(dLng / 2)
    return 2 * EARTH_RADIUS_KM * asin(sqrt(h))
}

/** This business's geocoded location, or null when it hasn't been geocoded yet. */
fun Business.location(): GeoPoint? {
    val lat = address.lat
    val lng = address.lng
    return if (lat != null && lng != null) GeoPoint(lat, lng) else null
}

/** Kilometres from [origin] to this business, or null when the business has no coordinates. */
fun Business.distanceKmFrom(origin: GeoPoint): Double? =
    location()?.let { distanceKm(origin, it) }
